import React from "react";
import { twMerge } from "tailwind-merge";

interface TextAreaProps {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  rows?: number;
  className?: string;
  wrapperClassName?: string;
  disabled?: boolean;
  readOnly?: boolean;
  required?: boolean;
}

export default function TextAreaBox({
  label,
  value,
  onChange,
  placeholder = "",
  rows = 4,
  className = "",
  wrapperClassName = "",
  disabled = false,
  readOnly = false,
  required = false,
}: TextAreaProps) {
  return (
    <div className={twMerge("relative", wrapperClassName)}>
      <div className="h-6 mb-1">
        <label className="block text-base font-normal text-[#414651]">
          {required && <span className="text-red-500 mr-1">*</span>}
          {label}
        </label>
      </div>
      <textarea
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        disabled={disabled}
        readOnly={readOnly}
        className={twMerge(
          "w-full bg-white border border-[#CCCCCC] rounded-sm px-2 py-2",
          "focus:outline-none focus:ring-2 focus:ring-[#55b938] focus:border-[#55b938]",
          "text-[#333333] placeholder:text-[#717680] resize-none",
          disabled ? "bg-gray-50 text-gray-400" : "",
          readOnly ? "bg-[#F5F5F5] cursor-default" : "",
          className
        )}
      />
    </div>
  );
}
